import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { IonicPageModule } from "ionic-angular";
import { ComponentsModule } from "../../components/components.module";
import { PipesModule } from "../../pipes/pipes.module";
import { BuyVouchersPage } from "./buy-vouchers";

@NgModule({
  declarations: [BuyVouchersPage],
  imports: [
    IonicPageModule.forChild(BuyVouchersPage),
    TranslateModule.forChild(),
    ComponentsModule,
    PipesModule,
  ],
  exports: [BuyVouchersPage],
})
export class BuyVouchersPageModule {}



// WEBPACK FOOTER //
// ./src/app/pages/buy-vouchers/buy-vouchers.module.ts